<template>
  <div
    :is-kiosk="isKiosk"
    id="signin"
    v-bind:class="{
      'is-loading': state.isLoading,
      'open-modal': state.openModal
    }"
  >
    <WelcomeScreen ref="welcomeScreen" :data="data" @print="printLabel" @signin="getLocalPostCallback" @skip="skipSignIn" />
    <MyVaccinePass
      v-if="!(this.$refs.welcomeScreen || {}).show && isKiosk && !state.isLoading && !signInWithQr && showMyVaccinePass && !this.$route.params.skipScreen"
      ref="myVaccinePass"
      :data="data"
      :qrCodeKioskSignInType="qrCodeKioskSignInType"
      @signin="signInWithMyVaccinePass"
    />
    <div class="loading__overlay loading__overlay--inverse">
      <div class="loading"></div>
    </div>
    <div v-show="!state.formCompleted && !$parent.errorMsg && data">
      <h1 v-if="data && data.branding">
        {{ data.branding.name }} - {{ data.name }} {{ pageName }}
      </h1>
      <div
        v-if="data && data.branding"
        class="ql-editor p-0"
        style="min-height: unset;"
        v-html="data.introduction === null || data.introduction === 'disabled' ? (data.branding || {}).introduction : data.introduction"></div>


      <form-builder
        ref="myFormBuilder"
        v-if="userData"
        :steps="steps"
        :callback="submit"
        :locationCode="$data.deviceCode"
        :hasBack="isKiosk"
        :hasNext="hasNext"
        @back="goBack"
      ></form-builder>



    </div>
  </div>
</template>

<script>
import WelcomeScreen from "@/components/WelcomeScreen";
import MyVaccinePass from "@/components/MyVaccinePass";
import FormBuilder from "@/components/FormBuilder.vue";
import { getCheckInDataMixin } from "@/mixins.js";

export default {
  name: "SignIn",
  mixins: [getCheckInDataMixin],
  components: {
    FormBuilder,
    WelcomeScreen,
    MyVaccinePass
  },
  data() {
    return {
      state: {
        openModal: false,
        isLoading: false,
        activeStep: 0,
        formCompleted: false,
        formCompletedMsg: "Sorry theres been an error"
      },
      defaultCompanyLabel:"Company Name",
      pageName: "Sign In",
      data: null,
      userData: {},
      steps: null,
      showSubmitFeedback: false,
      hasNext: false,
      signInWithQr: false,
      qrCodeKioskSignInType: 0
    };
  },
  computed: {
    isKiosk() {
      return window.location.hostname.includes('kiosk.');
    },
    showMyVaccinePass() {
      return this.qrCodeKioskSignInType === 1 || this.qrCodeKioskSignInType === 2;
    }
  },
  created() {
    this.reloadSteps();
    console.log("signin >>> ");
    if (!this.$route.params.skipScreen) {
      this.removeQrCodeContent();
    } else {
      this.steps[0].fields[0].disabled = true;
    }
    console.log('this.$data.rememberMe.showCreated', this.$data?.rememberMe);


    this.$parent.errorMsg = null;
    this.getLocalPost(this.getLocalPostCallback);
    if (window.location.hostname.includes("kiosk."))
      localStorage.removeItem("userVisitorData");
  },
  methods: {
    signInWithMyVaccinePass(userData, signInWithQr, disabled) {
      this.signInWithQr = signInWithQr;
      this.steps[0].fields[0].disabled = disabled;
      this.getLocalPostCallback(userData);
    },
    reloadSteps() {
      this.steps = [
        {
          title: "Your Info",
          fields: [
            {
              type: "text",
              label: "Full Name",
              name: "name",
              rules: "required",
              autocomplete: true,
              value: "",
              disabled: false
            },
            {
              type: "email",
              label: "Email Address",
              name: "email",
              condition: "email",
              value: ""
            },
            {
              type: "mobile",
              label: "Phone",
              name: "mobile",
              rules: {
                required: true,
                phonenumber: true
              },
              value: null
            },
            {
              type: "radio",
              label: "What is your role",
              name: "contactType",
              rules: "required",
              options: ["Employee"],
              value: "",
              listeners: {
                change: (event, field, option) => {
                  this.steps[0].fields[4].label = (option.companyParlance ? option.companyParlance : this.defaultCompanyLabel)
                }
              }
            },
            {
              type: "text",
              label: this.defaultCompanyLabel,
              name: "companyName",
              condition: "companyName",
              value: ""
            },

            {
              type: "check",
              label: "I have dependants/minors with me",
              condition: "dependants",
              name: "hasDependants",
              value: "true",
              rules: {
                required: false,
              }
            },

            {
              type: "number",
              label: "How many dependants are visiting with you?",
              name: "dependants",
              condition: "dependants",
              displayCondition: "hasDependants",
              rules: {
                required: true,
              },
              value: ""
            },
            {
              type: "check",
              label: "Remember Me - Make Sign In Faster",
              name: "rememberMe",
              hidden: true
            },
            {
              type: "hidden",
              label: "Contact Id",
              name: "contactId"
            }
            /*,
            {
              type: "text",
              label: "Person Visiting",
              name: "personVisiting",
              rules: "",
              value: "",
              showCondition: true
            }*/
          ]
        }
      ]
    },
    getLocalPostCallback(userData) {

      console.log("userData:getLocalPostCallback", userData);
      console.log("!(this.$refs.myVaccinePass || {}).isValid >>> ", !(this.$refs.myVaccinePass || {}).isValid);
      this.userData = userData;
      this.getCheckInData(
        this.$route.params.id,
        this.getDataCallback,
        userData
      );
    },
    getDataCallback() {
      let me = this;
      if(me.isKiosk){//Remember Me checkbox hidden in kioskMode
        this.steps[0].fields[7].hidden = !this.$data?.rememberMe?.show;
        this.steps[0].fields[7].CHKvalue = this.$data?.rememberMe?.checked;
      }

      // SETTING QR CODE KIOSK SIGN IN TYPE
      console.log("this.$data.locationData >>> ", this.$data);
      this.qrCodeKioskSignInType = (this.$data.locationData || {}).qrCodeKioskSignInType;



      if (this.data.contactTypes && this.data.contactTypes.length) {
        this.steps[0].fields[3].options = this.data.contactTypes;
        console.log("userData", this.userData);

        if (this.userData && this.userData.visitor) {
          var contactTypes = false;
          if (this.userData.visitor.contactType) {
            console.log("contactType", this.userData.visitor.contactType);
            this.data.contactTypes.forEach(function(item) {
              //Do something
              if (item.id === me.userData.visitor.contactType.id) {
                contactTypes = true;
                return false;
              }
            });
          }

          if (
            !contactTypes &&
            this.data.contactTypes &&
            this.data.contactTypes.length > 0
          ) {
            me.userData.visitor.contactType = this.data.contactTypes[0];
          }

          me.steps[0].fields.forEach(function(item) {
            //Do something
            if (
              item.name === "contactType" &&
              me.userData.visitor &&
              me.userData.visitor[item.name]
            ) {
              item['hidden'] = item.options.length === 1
              item['value'] = (me.data.contactTypes || []).find(
                o => o.id === me.userData.visitor[item.name].id

              );
              return;
            }

            if (item.name === "companyName") {
              item.label = (((me.userData || {}).visitor || {}).contactType || {}).companyParlance || me.defaultCompanyLabel;
            }
            item.value = me.userData.visitor[item.name];
          });

        }
      } else {
        me.userData.visitor.contactType = null;
        this.steps[0].fields.splice(3, 1);
      }

      const { questionSet } = ((me.userData.visitor || {}).contactType || {});
      const questions = questionSet && questionSet.questions ? questionSet.questions : this.data.questions;
      this.hasNext = questions && questions.length > 0;
      this.addMetaTagAppIcons();
    },
    submit() {
      let me = this;
      this.steps[0].fields.forEach(function(item) {
        if (item.type !== "mobile" && item.type !== "check") {
          me.userData.visitor[item.name] = item.value;
        }else if (item.type === "check") {
          me.userData.visitor[item.name] = item.CHKvalue;
        } else {
          me.userData.visitor[item.name] = item.valueObj.e164;
        }
      });

      console.log("this.userData >>> ", this.userData);
      this.removeHiddenFields();
      this.redirect(this.userData)
    },
    removeHiddenFields() {
      const userData = {...this.userData}
      const visitor = (userData || {}).visitor || {};
      const contactType = (visitor || {}).contactType || {};
      const rules = (contactType || {}).rules || undefined;
      if (rules) {
        for (var [key, value] of Object.entries(rules)) {
          // eslint-disable-next-line no-prototype-builtins
          if (value === 4 && this.userData.visitor.hasOwnProperty(key)) {
            if (key === "dependants") delete this.userData.visitor.hasDependants;
            delete this.userData.visitor[key];
          }
        }
      }
    },
    redirect (data) {
      //Clear any previously sent form data
      localStorage.removeItem("userFormSentData");

      const parsed = JSON.stringify(data.visitor);
      console.log("parsed >>> ", {parsed});
      localStorage.setItem("userVisitorData", parsed);

      console.log("contactType", data.visitor.contactType);

      this.$router.push({
        name: "agree",
        params: { id: this.$route.params.id }
      });
    },
    goBack() {
      // if (this.showWelcomeScreen) this.$refs.welcomeScreen.show = true;
      this.removeQrCodeContent();
      if (this.isKiosk && this.showMyVaccinePass && this.$data.actionTimer < 60) {
        this.$route.params.skipScreen = undefined;
        let userData = this.userData;
        userData.visitor.name = "";
        this.signInWithMyVaccinePass(userData, false, false);
        (this.$refs.myVaccinePass || {}).show = true;
      } else {
        if (this.showWelcomeScreen) this.$refs.welcomeScreen.show = true;
      }
    },
    skipSignIn (data) {
      this.redirect(data)
    },
    addMetaTagAppIcons() {
      try {
        let appIcons = localStorage.getItem("appIcons");
        if (appIcons !== null) {
          appIcons = JSON.parse(localStorage.getItem("appIcons"));
          const signInCode = localStorage.getItem("signInCode");
          appIcons.forEach(appIcon => {
            const {src, sizes, type} = appIcon;
            let link = document.createElement('link');
            link.id = signInCode;
            link.rel = "icon";
            link.type = type;
            link.sizes = sizes;
            link.href = src;
            window.document.getElementsByTagName('head')[0].appendChild(link);
          });

          appIcons.forEach(appIcon => {
            const {src, sizes} = appIcon;
            let link = document.createElement('link');
            link.id = signInCode;
            link.rel = "apple-touch-icon";
            link.sizes = sizes;
            link.href = src;
            window.document.getElementsByTagName('head')[0].appendChild(link);
          })
          console.log("addMetaTagAppIcons >>> ", appIcons);
        }
      } catch (err) {
        console.log("addMetaTagAppIcons err >>> ", err);
      }
    }
  },
  mounted() {
    if (this.$route.params.skipScreen || !this.showWelcomeScreen) {
      this.$refs.welcomeScreen.show = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
